"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooterBase = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var getClassNames = (0, Utilities_1.classNamesFunction)();
var DialogFooterBase = /** @class */ (function (_super) {
    tslib_1.__extends(DialogFooterBase, _super);
    function DialogFooterBase(props) {
        var _this = _super.call(this, props) || this;
        (0, Utilities_1.initializeComponentRef)(_this);
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    DialogFooterBase.prototype.render = function () {
        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
        });
        return (React.createElement("div", { className: this._classNames.actions },
            React.createElement("div", { className: this._classNames.actionsRight }, this._renderChildrenAsActions())));
    };
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    DialogFooterBase.prototype._renderChildrenAsActions = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            return child ? React.createElement("span", { className: _this._classNames.action }, child) : null;
        });
    };
    return DialogFooterBase;
}(React.Component));
exports.DialogFooterBase = DialogFooterBase;
//# sourceMappingURL=DialogFooter.base.js.map